export const FeatureState =(type) => {
    const fs = [
        {id: 1, action: 2, feature_name: 'dashboard', path: '1'},
        {id: 2, action: 2, feature_name: 'takeexam', path: '2'},
        {id: 3, action: 2, feature_name: 'myreviewer', path: '3'},
        {id: 4, action: 2, feature_name: 'leaderboard', path: '4'},
        {id: 5, action: 2, feature_name: 'toolcategories', path: '5'},
        
    ]

    const findFeature =(data, targetFeatureName) => {
        for (const i of data) {
            if (i.feature_name.toLowerCase() === targetFeatureName.toLowerCase()) {
                return i
            }
            if (i.sub_feature) {
                const found_data = findFeature(i.sub_feature, targetFeatureName)
                if (found_data) return found_data
            }
        }
    }

    const filter = findFeature(fs, type)
    return filter
}